import { css } from '@emotion/react';

export const startNewTrial = css`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 4px;
`;

export const verifyEmail = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  > p {
    margin: 0;
  }
`;
